export default __webpack_public_path__ + "static/media/2267.36e60095.png";